<div class="xi-modal__container" *transloco="let t; read: 'dashboard-page-rename-dialog-component'">
  <h2 class="xi-modal__title">{{ t('title') }}</h2>

  <div class="xi-modal__content">
    <h5 class="dashboard-page_rename__subtitle">
      {{ t('header') }}
    </h5>

    <div class="xi-input-field-wrapper">
      <xi-input-field
        name="pageName"
        label="{{ t('label') }}"
        [(ngModel)]="pageName"
        [status]="pageNameStatus"
        (onChange)="onValidatePageName()"
        required
      ></xi-input-field>
    </div>
  </div>

  <div class="xi-modal__actions">
    <xi-default-button
      text="{{ t('cancel') }}"
      fill="text"
      (onClick)="cancel()"
    ></xi-default-button>
    <xi-default-button
      text="{{ t('save') }}"
      [disabled]="!isValid"
      (onClick)="save()"
    ></xi-default-button>
  </div>
</div>
